export const taxationData = {
  Hungary: [
    {
      'Name of the programme': 'KIVA– Small Business Tax (Kisvállalati Adó)',
      'Program summary':
        'A preferential tax regime for SMEs replacing corporate tax and social contribution tax, designed to reduce administrative burden and support business growth.',
      Website:
        'https://nav.gov.hu/pfile/file?path=/ugyfeliranytu/nezzen-utana/inf_fuz/rejtett/Informacios-fuzetek---Aktualis/92.-informacios-fuzet---a-kisvallalati-ado-szabalyozasa',
      Contact: 'ugyfelszolgalat@nav.gov.hu'
    },
    {
      'Name of the programme': 'KATA (Small Taxpayers’ Itemised Lump Sum Tax – updated regime)',
      'Program summary':
        'Simplified taxation scheme for eligible small entrepreneurs and sole traders, offering predictable fixed-rate taxation under specific eligibility rules.',
      Website:
        'https://nav.gov.hu/pfile/file?path=/ugyfeliranytu/nezzen-utana/inf_fuz/2026/99.-Kisadozo-vallalkozok-teteles-adoja-kata-2026.-01.-08',
      Contact: 'ugyfelszolgalat@nav.gov.hu'
    },
    {
      'Name of the programme': 'Exemption from innovation contribution',
      'Program summary':
        'The Hungarian innovation contribution is a 0.3% levy on the local business tax base payable by most domestic companies under accounting rules, while micro- and small enterprises are exempt, and the obligation is assessed and declared annually with advance quarterly payments',
      Website:
        'https://nav.gov.hu/pfile/file?path=/ugyfeliranytu/nezzen-utana/inf_fuz/2026/68.-Az-innovacios-jarulek-legfontosabb-szabalyai-2026.-02.-02',
      Contact: ''
    },
    {
      'Name of the programme': 'Széchenyi Card Programme – Interest Subsidy Scheme',
      'Program summary':
        'State-supported financial instrument providing subsidised loans and guarantees to SMEs to improve access to finance and liquidity.',
      Website: 'https://kavosz.hu/',
      Contact: 'info@kavosz.hu'
    }
  ],
  Romania: [
    {
      'Name of the programme': 'Tax exemption for reinvested profit',
      'Program summary':
        'Corporate income tax exemption for profit reinvested in technological equipment, digitalisation, automation and productivity-related assets, supporting competitiveness and transition to a green and digital economy.',
      Website: 'https://www.anaf.ro',
      Contact: 'National Agency for Fiscal Administration (ANAF) – anaf@anaf.ro'
    },
    {
      'Name of the programme': 'R&D tax incentive',
      'Program summary':
        'Additional 50% deduction of eligible R&D expenses from taxable profit and accelerated depreciation for R&D equipment, encouraging innovation and smart specialisation.',
      Website: 'https://mfinante.gov.ro',
      Contact: 'Ministry of Finance – ajutor.stat@mfinante.gov.ro'
    },
    {
      'Name of the programme': 'State Aid Scheme HG 807/2014',
      'Program summary':
        'State aid scheme providing non-reimbursable grants for large investments that promote regional development, job creation and industrial competitiveness.',
      Website: 'https://mfinante.gov.ro/hg-807-2014',
      Contact: 'Ministry of Finance – ajutor.stat@mfinante.gov.ro'
    },
    {
      'Name of the programme': 'Green certificates support scheme',
      'Program summary':
        'Market-based support mechanism for renewable energy producers through tradable green certificates, contributing to decarbonisation and circular economy goals.',
      Website: 'https://www.anre.ro',
      Contact: 'National Energy Regulatory Authority (ANRE) – relatii.publice@anre.ro'
    }
  ],
  Germany: [
    {
      'Name of the programme': 'R&D Tax Credit (Forschungszulage)',
      'Program summary':
        'Tax incentive allowing companies (including start-ups) to claim 25% of eligible R&D personnel and contract costs as a refundable tax credit (up to €1 million credit per year). In effect since 2020.',
      Website:
        'https://www.bundesfinanzministerium.de/Content/EN/Standardartikel/Topics/Taxation/Articles/2020-01-14-tax-incentive-for-research.html',
      Contact: 'forschungszulage@bundesfinanzministerium.de'
    },
    {
      'Name of the programme': 'INVEST – Venture Capital Grant',
      'Program summary':
        'Federal scheme to encourage private investment in start-ups. Private investors receive a 20% grant (up to €100k) on their equity investment in a start-up, plus tax exemption on capital gains after 3 years. Administered by BAFA.',
      Website: 'https://www.bafa.de/EN/Invest/invest_node.html',
      Contact: 'invest@bafa.bund.de'
    },
    {
      'Name of the programme': 'Gründungszuschuss (Start-up Grant)',
      'Program summary':
        'Allowance from the Federal Employment Agency for unemployed individuals starting a business. Provides approx. €300 per month on top of unemployment benefits for 6–9 months to support living costs during the launch phase.',
      Website: 'https://www.arbeitsagentur.de/en/self-employment-funding',
      Contact: 'Federal Employment Agency (via local Jobcenter)'
    },
    {
      'Name of the programme': 'Mikromezzaninfonds Deutschland',
      'Program summary':
        'Public–private fund offering silent equity capital up to €75,000 to small businesses and start-ups, with focus on socially or environmentally sustainable enterprises. Helps improve capital base without collateral.',
      Website: 'https://www.mikromezzaninfonds-deutschland.de',
      Contact: 'info@mikromezzaninfonds-deutschland.de'
    },
    {
      'Name of the programme': 'Bürgschaftsbank BW Loan Guarantees',
      'Program summary':
        'State-backed guarantee bank providing guarantees for bank loans to new and small businesses in Baden-Württemberg. Covers up to 80% of loan amount (max ~€1.25 million), facilitating financing for start-ups lacking collateral.',
      Website: 'https://www.buergschaftsbank.de',
      Contact: 'info@buergschaftsbank.de'
    }
  ],
  Austria: [
    {
      'Name of the programme': 'research bonus',
      'Program summary':
        'A research bonus of 14 percent (before January 1, 2018: 12 percent) of research expenses can be claimed for research and experimental development expenses. Both in-house research and commissioned research are eligible for the bonus.',
      Website: 'https://www.ffg.at/forschungspraemie',
      Contact: 'https://www.ffg.at/beratung'
    },
    {
      'Name of the programme': 'Device rescue bonus',
      'Program summary':
        'As the successor to the repair bonus, the device rescue bonus supports the repair, servicing, and maintenance of electrical and electronic devices.',
      Website:
        'https://www.oesterreich.gv.at/de/themen/umwelt_und_klima/energie_und_ressourcen_sparen/geraete-retter-praemie',
      Contact: 'https://www.xn--gerte-retter-prmie-ntbm.at/'
    },
    {
      'Name of the programme': 'Investment allowance for companies',
      'Program summary':
        'The investment allowance (IFB) in Austria is a tax relief for companies that invest in depreciable assets. From November 1, 2025, the IFB for standard investments will be 20% of the acquisition or production costs, while for ecological investments it will be 22%.',
      Website: 'https://www.wko.at/steuern/investitionsfreibetrag',
      Contact: 'https://www.wko.at/kontaktformular-wkoe'
    }
  ],
  Moldova: [
    {
      'Name of the programme': 'Regional State Aid Scheme for Investments',
      'Program summary':
        'State support scheme offering grants and partial income tax exemptions to companies making investments in priority industrial sectors (electronics, textile, building materials, food industry, etc.). Grants cover ~25% and tax exemptions up to ~75% of eligible investment.',
      Website: 'https://invest.gov.md/en/support-for-strategic-industrial-investments-in-the-republic-of-moldova/',
      Contact: 'Ministry of Economic Development and Digitisation'
    },
    {
      'Name of the programme': 'Moldova Innovation Technology Park (MITP) Tax Regime',
      'Program summary':
        'Special fiscal regime allowing IT Park residents to pay a flat 7% tax on turnover (covering multiple taxes), plus additional incentives (tax and customs exemptions) to promote innovation and business growth',
      Website: 'https://invest.gov.md/en/incentives-2/',
      Contact: 'Invest Moldova (Agency for Investment)'
    },
    {
      'Name of the programme': 'Zero % Tax on Reinvested Profits (SMEs)',
      'Program summary':
        'Tax incentive that exempts qualifying SMEs from profit tax on reinvested earnings, supporting reinvestment and expansion.',
      Website: 'https://logos-pres.md/en/news/small-businesses-to-extend-tax-incentives/',
      Contact: 'Parliament / Ministry of Finance'
    }
  ],
  Croatia: [
    {
      'Name of the programme': 'R&D Tax Incentives (Porezne olakšice za istraživanje i razvoj)',
      'Program summary':
        'Corporate income tax deductions for eligible R&D activities, including innovation, digitalisation, and green technologies. Administered through the tax system with verification by competent bodies.',
      Website: 'https://www.porezna-uprava.hr',
      Contact: 'Ministry of Finance of the Republic of Croatia'
    },
    {
      'Name of the programme': 'Tax incentives for reinvested profit',
      'Program summary':
        'Corporate tax relief for profits reinvested into business development, employment, and fixed assets. Encourages SME growth and long-term sustainability.',
      Website: 'https://www.porezna-uprava.hr',
      Contact: 'Ministry of Finance of the Republic of Croatia'
    },
    {
      'Name of the programme': 'Investment Promotion Measures Act (Zakon o poticanju ulaganja)',
      'Program summary':
        'Tax reductions and financial incentives for investments in manufacturing, technology, digital transformation, and green economy, including job creation incentives.',
      Website: 'https://investcroatia.gov.hr',
      Contact: 'Ministry of Finance of the Republic of Croatia'
    },
    {
      'Name of the programme': 'HAMAG-BICRO SME Financial Instruments',
      'Program summary':
        'Grants, guarantees, soft loans and vouchers for SMEs, startups, innovation, digitalisation, and women entrepreneurship. Strong complementarity with EU-funded projects.',
      Website: 'https://hamagbicro.hr',
      Contact: 'HAMAG-BICRO'
    },
    {
      'Name of the programme': 'Environmental Protection and Energy Efficiency Fund Incentives',
      'Program summary':
        'Subsidies, co-financing and incentives for energy efficiency, renewable energy, circular economy solutions, waste management, and green innovation.',
      Website: 'https://www.fzoeu.hr',
      Contact: 'Environmental Protection and Energy Efficiency Fund'
    },
    {
      'Name of the programme': 'Employment and Training Incentives',
      'Program summary':
        'Wage subsidies, employment incentives for vulnerable groups (women, youth, 50+), reskilling and upskilling programmes aligned with digital and green transition.',
      Website: 'https://mjere.hzz.hr/',
      Contact: 'Croatian Employment Service'
    },
    {
      'Name of the programme': 'Local and regional tax relief schemes',
      'Program summary':
        'Municipal-level incentives such as reduced surtax, utility fees, or local tax reliefs for entrepreneurs, startups, and investors (varies by city/region).',
      Website: 'https://gov.hr',
      Contact: 'Local authorities (cities/counties'
    }
  ],
  Slovenia: [
    {
      'Name of the programme': 'Corporate tax incentives',
      'Program summary':
        'Slovenia offers extensive corporate tax reliefs: 100% R&D allowance, 40% allowance for digital & green investments, 40% allowance for equipment & intangibles, and strong employment incentives (e.g., +80% for trainees, +45–55% for deficit jobs and youth). These can reduce the tax base by up to 63%.',
      Website: 'https://taxsummaries.pwc.com/slovenia/corporate/tax-credits-and-incentives',
      Contact: ''
    }
  ],
  Czechia: [
    {
      'Name of the programme': 'Investment Incentives',
      'Program summary':
        'National regime under Act No 72/2000 Coll. offering corporate income tax relief for up to 10 years, job creation grants, training/re-training grants, cash support for asset acquisition and transfer of land at preferential price for qualifying investment projects.',
      Website: 'https://portal.gov.cz/en/informace/investment-incentives-INF-231',
      Contact: 'arbitr@finarbitr.cz'
    },
    {
      'Name of the programme': 'R&D Tax Deduction (Research and Development Tax Allowance)',
      'Program summary':
        'Allows companies to deduct eligible R&D costs from the corporate tax base, reducing effective tax liability and supporting private investment in innovation and technology development.',
      Website: 'https://www.mfcr.cz/cs/rozpoctova-politika/rozpoctove-ramce-statisticke-informace/danove-ulevy',
      Contact: 'podatelna@mfcr.cz'
    }
  ],
  'Bosnia and Herzegovina': [
    {
      'Name of the programme': 'Corporate Income Tax Incentives for Investment (FBiH)',
      'Program summary':
        'Corporate income tax reductions/exemptions for companies investing in fixed assets, production capacity, employment and export-oriented activities, according to entity tax legislation.',
      Website: 'https://www.pufbih.ba',
      Contact: 'info@pufbih.ba'
    },
    {
      'Name of the programme': 'Corporate Income Tax Incentives for Investment (RS)',
      'Program summary':
        'Tax reliefs for investments in production, equipment, and employment under RS corporate tax regulations.',
      Website: 'https://www.poreskaupravars.org',
      Contact: 'info@poreskaupravars.org'
    },
    {
      'Name of the programme': 'Customs and VAT Exemptions for Donor-Funded Projects',
      'Program summary':
        'VAT and customs exemptions for projects financed by international donors and EU funds, based on BiH VAT legislation and international agreements.',
      Website: 'https://www.uino.gov.ba',
      Contact: 'info@uino.gov.ba'
    },
    {
      'Name of the programme': 'Employment Subsidies and Social Contribution Reliefs',
      'Program summary':
        'Wage subsidies and contribution reliefs for hiring unemployed persons, youth, women, and vulnerable groups, implemented through employment institutes.',
      Website: 'https://www.fzzz.ba',
      Contact: 'Via employment institutes'
    },
    {
      'Name of the programme': 'Innovation and R&D Cost Recognition (Tax Deductibility)',
      'Program summary':
        'R&D and innovation-related business costs can be recognised as deductible business expenses in corporate taxation.',
      Website: 'https://www.uino.gov.ba',
      Contact: 'info@uino.gov.ba'
    },
    {
      'Name of the programme': 'Local Government Business Incentives',
      'Program summary':
        'Local tax reductions, utility fee discounts, land-use benefits and administrative facilitation for investors and SMEs.',
      Website: 'https://www.fmrpo.gov.ba',
      Contact: 'Via local authorities'
    },
    {
      'Name of the programme': 'Free Zones Incentives',
      'Program summary':
        'Tax and customs advantages for companies operating in registered free zones (import/export facilitation, VAT relief).',
      Website: 'https://www.mvteo.gov.ba',
      Contact: 'info@mvteo.gov.ba'
    },
    {
      'Name of the programme': 'Green Energy Feed-in Premiums and Incentives',
      'Program summary':
        'Financial incentives for renewable energy production, energy efficiency and grid integration under entity energy frameworks.',
      Website: 'https://www.fmer.gov.ba',
      Contact: 'Via energy regulators'
    },
    {
      'Name of the programme': 'Agricultural Tax and Contribution Incentives',
      'Program summary':
        'Reduced tax burden and financial incentives for registered agricultural producers and cooperatives.',
      Website: 'https://www.fmpvs.gov.ba',
      Contact: 'Via entity ministries'
    }
  ],
  'Slovak republic': [
    {
      'Name of the programme': 'R&D Superdeduction',
      'Program summary':
        'Firms can deduct eligible R&D expenses from the tax base, including additional bonus for growth in R&D expenditure. Defined in § 30c Zákona č. 595/2003 Z. z. – Zákon o dani z príjmov.',
      Website: 'https://www.slov-lex.sk/ezbierky/pravne-predpisy/SK/ZZ/2003/595/',
      Contact: 'Ministry of Finance SR - info@finance.gov.sk'
    },
    {
      'Name of the programme': 'Patent Box',
      'Program summary':
        'Partial tax exemption on income from patents, utility models, or software IP. Defined in § 13a and § 13b Zákona č. 595/2003 Z. z. – Zákon o dani z príjmov.',
      Website: 'https://www.slov-lex.sk/ezbierky/pravne-predpisy/SK/ZZ/2003/595/',
      Contact: 'Ministry of Finance SR - info@finance.gov.sk'
    },
    {
      'Name of the programme': 'Regional Investment Incentives',
      'Program summary':
        'Government-supported incentives for approved new investments in designated regions. Can include tax relief on corporate income, direct grants, support for job creation, and reduced costs for land or facilities. Governed by Investment Aid Act and regional aid maps.',
      Website: 'https://www.sario.sk/en/invest-slovakia/investment-incentives/regional-investment-incentives',
      Contact: 'SARIO – info@sario.sk'
    }
  ],
  BiH: [
    {
      'Name of the programme': 'Corporate Income Tax Incentives for Investment (FBiH)',
      'Program summary':
        'Corporate income tax reductions/exemptions for companies investing in fixed assets, production capacity, employment and export-oriented activities, according to entity tax legislation.',
      Website: 'https://www.pufbih.ba',
      Contact: 'info@pufbih.ba'
    },
    {
      'Name of the programme': 'Corporate Income Tax Incentives for Investment (RS)',
      'Program summary':
        'Tax reliefs for investments in production, equipment, and employment under RS corporate tax regulations.',
      Website: 'https://www.poreskaupravars.org',
      Contact: 'info@poreskaupravars.org'
    },
    {
      'Name of the programme': 'Customs and VAT Exemptions for Donor-Funded Projects',
      'Program summary':
        'VAT and customs exemptions for projects financed by international donors and EU funds, based on BiH VAT legislation and international agreements.',
      Website: 'https://www.uino.gov.ba',
      Contact: 'info@uino.gov.ba'
    },
    {
      'Name of the programme': 'Employment Subsidies and Social Contribution Reliefs',
      'Program summary':
        'Wage subsidies and contribution reliefs for hiring unemployed persons, youth, women, and vulnerable groups, implemented through employment institutes.',
      Website: 'https://www.fzzz.ba',
      Contact: 'Via employment institutes'
    },
    {
      'Name of the programme': 'Innovation and R&D Cost Recognition (Tax Deductibility)',
      'Program summary':
        'R&D and innovation-related business costs can be recognised as deductible business expenses in corporate taxation.',
      Website: 'https://www.uino.gov.ba',
      Contact: 'info@uino.gov.ba'
    },
    {
      'Name of the programme': 'Local Government Business Incentives',
      'Program summary':
        'Local tax reductions, utility fee discounts, land-use benefits and administrative facilitation for investors and SMEs.',
      Website: 'https://www.fmrpo.gov.ba',
      Contact: 'Via local authorities'
    },
    {
      'Name of the programme': 'Free Zones Incentives',
      'Program summary':
        'Tax and customs advantages for companies operating in registered free zones (import/export facilitation, VAT relief).',
      Website: 'https://www.mvteo.gov.ba',
      Contact: 'info@mvteo.gov.ba'
    },
    {
      'Name of the programme': 'Green Energy Feed-in Premiums and Incentives',
      'Program summary':
        'Financial incentives for renewable energy production, energy efficiency and grid integration under entity energy frameworks.',
      Website: 'https://www.fmer.gov.ba',
      Contact: 'Via energy regulators'
    },
    {
      'Name of the programme': 'Agricultural Tax and Contribution Incentives',
      'Program summary':
        'Reduced tax burden and financial incentives for registered agricultural producers and cooperatives.',
      Website: 'https://www.fmpvs.gov.ba',
      Contact: 'Via entity ministries'
    }
  ],
  Serbia: [
    {
      'Name of the programme': 'Tax Relief for Hiring New Employees',
      'Program summary': 'Reduction of taxes and contributions for newly employed staff.',
      Website: 'https://www.purs.gov.rs/',
      Contact: 'kabinet@purs.gov.rs'
    },
    {
      'Name of the programme': 'Flat-Rate Taxation (Paushal)',
      'Program summary': 'Simplified taxation for small entrepreneurs; fixed tax and reduced administrative burden.',
      Website: 'https://www.purs.gov.rs/',
      Contact: 'kabinet@purs.gov.rs'
    }
  ]
}
